import { useEffect } from "react";
import { ContainerAtualizarDadosCadastrais } from "./styles";
import logotipo from "../../assets/images/logo-conecta-venda-horizontal.svg";

const SUPERLOGICA_URL =
  "https://conectavenda.superlogica.net/clients/areadocliente";

export const AtualizarDadosCadastrais: React.FC = () => {
  useEffect(() => {
    const id = "google-fonts-inter-atualizar-dados";
    if (document.getElementById(id)) return;

    const preconnect1 = document.createElement("link");
    preconnect1.rel = "preconnect";
    preconnect1.href = "https://fonts.googleapis.com";

    const preconnect2 = document.createElement("link");
    preconnect2.rel = "preconnect";
    preconnect2.href = "https://fonts.gstatic.com";
    preconnect2.crossOrigin = "anonymous";

    const fontLink = document.createElement("link");
    fontLink.id = id;
    fontLink.rel = "stylesheet";
    fontLink.href =
      "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap";

    document.head.appendChild(preconnect1);
    document.head.appendChild(preconnect2);
    document.head.appendChild(fontLink);
  }, []);

  return (
    <ContainerAtualizarDadosCadastrais>
      <div className="bg-atualizar-dados">
        <div className="conteudo-atualizar">
          <div className="card-atualizar">
            <h2 className="titulo-atualizar">
              Atualização de dados cadastrais
            </h2>
            <img
              src={logotipo}
              alt="Conecta Venda"
              className="logo-atualizar"
            />
            <div className="texto-complementar">
              <p>
                Clique no botão abaixo para acessar e atualizar suas
                informações cadastrais com segurança.
              </p>
            </div>
            <a
              className="botao-atualizar"
              href={SUPERLOGICA_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Acessar área do cliente
            </a>
          </div>
        </div>
      </div>
    </ContainerAtualizarDadosCadastrais>
  );
};